import {useState, useCallback} from 'react';
import debounce from 'lodash.debounce';

// Code is based on the following gist
// https://gist.github.com/Haraldson/8bdee011b10fdaf746787585a79e91ce
export function useDebounce<T>(
  defaultValue: T,
  delay: number,
): [T, (value: T) => void, {signal: number; debouncing: boolean}] {
  const [value, setValueImmediately] = useState(defaultValue);
  const [debouncing, setDebouncing] = useState(false);
  const [signal, setSignal] = useState(Date.now());

  // NOTE: debounce needs to be called directly
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const triggerUpdate = useCallback(
    debounce(() => {
      setDebouncing(false);
      setSignal(Date.now());
    }, delay),
    [delay],
  );

  const setValue = useCallback(
    (value) => {
      setValueImmediately(value);
      setDebouncing(true);
      triggerUpdate();
    },
    [triggerUpdate],
  );

  return [
    value,
    setValue,
    {
      signal,
      debouncing,
    },
  ];
}
